var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrownInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3583_11138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.80446 11.8085C9.41312 11.8085 11.5279 9.69373 11.5279 7.08507C11.5279 4.4764 9.41312 2.36166 6.80446 2.36166C4.19579 2.36166 2.08105 4.4764 2.08105 7.08507C2.08105 9.69373 4.19579 11.8085 6.80446 11.8085Z",
    stroke: "#293A3A",
    strokeWidth: 0.899696,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80469 4.98578H6.81264",
    stroke: "#293A3A",
    strokeWidth: 0.899696,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28027 7.08507H6.8051V9.18436H7.32992",
    stroke: "#293A3A",
    strokeWidth: 0.899696,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3583_11138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.506836 0.787201H13.1026V8.80349C13.1026 11.3327 11.0523 13.3829 8.52313 13.3829H5.08629C2.55713 13.3829 0.506836 11.3327 0.506836 8.80349V0.787201Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrownInfoIcon);
export default __webpack_public_path__ + "static/media/brown-info-icon.638f97cd5d63238ec27cad7eafce814a.svg";
export { ForwardRef as ReactComponent };